import styled from 'styled-components';
import { IconButton } from '../../../IconButton';
export var StyledRowIconButton = styled(IconButton).withConfig({
  displayName: "styled__StyledRowIconButton",
  componentId: "sc-1t3sc3c-0"
})(["padding:5px;margin:0 2px;"]);